'use strict';

determineAward.classy.controller({
    name: 'RightDetermineAwardController',
    inject: ['$scope', '$q', 'authServiceFactory', 'SchoolModelService', 'AppModelService', 'ApplicationService', 'AccountModelService', 'BinFactory',
        'BudgetsModelService', 'ApplicationSideBarService', 'DetermineAwardService'],
    init: function()
    {
        this.$.selectedAccount = [];
        this.$.remainingAward = [];
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.ApplicationService = this.ApplicationService;
        this.setAwardType();
        this.buildAwardPutObject();
        this.buildBudgetPutObject(this.ApplicationService.getAwardData().applicants);

        // Determine if this school has active budgets available
        this.$.hasActiveBudgets = false;
        for (var i = 0; i < this.ApplicationService.getAwardData().applicants[0].budgets.length; i++) {
            if (this.ApplicationService.getAwardData().applicants[0].budgets[i].Active==1 && this.ApplicationService.getAwardData().applicants[0].budgets[i].deleted==0)
                this.$.hasActiveBudgets = true;
        }

        // jQuery to resize award container on window resize
        $(window).on('resize', function(){
            var height = $(this).height() - 336;
            $('.applicants-award-container').css('max-height', height + 'px');
        }).trigger('resize');
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    },
    calculateTotalAward: function(index) {
        this.$.awardPutObject.applicants[index].Act_Award = this.$.awardPutObject.applicants[index].Act_Award_F1 + this.$.awardPutObject.applicants[index].Act_Award_F2; 
    },
    // method is run when awards/budgets are changed
    // calculates remaining award
    calculateRemainingAward: function(applIndex, type)
    {
        if (((type==undefined || type==0 || type==1) && (this.$.budgetPutObject[applIndex]!==undefined || this.$.awardPutObject.applicants[applIndex].Act_Award!==undefined))) {
            var sum = 0;
            if (this.$.awardPutObject.applicants[applIndex].Act_Award > this.$.awardPutObject.applicants[applIndex].App_Tuition)
                this.$.awardValid = false;
            else
                this.$.awardValid = true;
            for (var budgetID in this.$.budgetPutObject[applIndex]) {
                if (this.$.budgetPutObject[applIndex][budgetID].award!=='' && this.$.budgetPutObject[applIndex][budgetID].award!==undefined) 
                    sum += parseInt(this.$.budgetPutObject[applIndex][budgetID].award);
            }
            if (this.$.awardType1!=1)
                this.$.remainingAward[applIndex] = this.$.awardPutObject.applicants[applIndex].Act_Award - sum;
            else 
                this.$.remainingAward[applIndex] = this.$.awardPutObject.applicants[applIndex].App_Tuition - this.$.awardPutObject.applicants[applIndex].Act_Award - sum;
        }
    },

    // set the award type from the determineawardservice
    setAwardType: function() {
        this.$.awardType = {
            'Award': 0,
            'Consider': 1,
            'Reject': 2
        }[this.DetermineAwardService.getAwardComplete()];
        if (!this.$.awardType) this.$.awardType=0;
        this.$.awardType1 = this.$.schoolinfo.Award_Pref_1;
        this.$.awardType2 = this.$.schoolinfo.Award_Pref_2;
    },

    // create the awardPutObject from app awardData
    buildAwardPutObject: function()
    {
        this.$.awardPutObject = { applicants: []};
        if (this.$.schoolinfo.Award_Pref_2==1) {
            this.$.awardPutObject.Rec_Aw = this.ApplicationService.getFamilyData().awardData.recommendedAward.recommendedAward;
        } else {
            this.$.awardPutObject.Rec_Aw = this.ApplicationService.getAwardData().awardData.recommendedAward.recommendedAward;
        }

        for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
            this.$.awardPutObject.applicants[i] = {};
            this.$.awardPutObject.applicants[i].recordID = this.ApplicationService.getAwardData().applicants[i].recordID;
            this.$.awardPutObject.applicants[i].App_Tuition = this.ApplicationService.getAwardData().applicants[i].App_Tuition;

            if (this.$.awardType1 != 1) {
                if (this.ApplicationService.getAwardData().applicants[i].ActAward > 0) 
                    this.$.awardPutObject.applicants[i].Act_Award = this.ApplicationService.getAwardData().applicants[i].ActAward;
                else if (this.ApplicationService.getAwardData().applicants[i].ConsiderAward > 0) 
                    this.$.awardPutObject.applicants[i].Act_Award = this.ApplicationService.getAwardData().applicants[i].ConsiderAward;
                else
                    this.$.awardPutObject.applicants[i].Act_Award = null;
            } else {
                if (this.ApplicationService.getAwardData().applicants[i].ActAward > 0)
                    this.$.awardPutObject.applicants[i].Act_Award = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ActAward;
                else if (this.ApplicationService.getAwardData().applicants[i].ConsiderAward > 0)
                    this.$.awardPutObject.applicants[i].Act_Award = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ConsiderAward;
                else
                    this.$.awardPutObject.applicants[i].Act_Award = null;
            }

            if (this.$.awardType2 == 1) {
                if (this.$.awardType1 != 1) {
                    if (this.ApplicationService.getAwardData().applicants[i].ActAward > 0) {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = this.ApplicationService.getAwardData().applicants[i].ActAward_F1;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = this.ApplicationService.getAwardData().applicants[i].ActAward_F2;
                    } else if (this.ApplicationService.getAwardData().applicants[i].ConsiderAward > 0) {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = this.ApplicationService.getAwardData().applicants[i].ConsiderAward_F1;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = this.ApplicationService.getAwardData().applicants[i].ConsiderAward_F2;
                    } else {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = null;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = null;
                    }
                } else {
                    if (this.ApplicationService.getAwardData().applicants[i].ActAward > 0) {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ActAward_F1;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ActAward_F2;
                    } else if (this.ApplicationService.getAwardData().applicants[i].ConsiderAward > 0) {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ConsiderAward_F1;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = this.ApplicationService.getAwardData().applicants[i].App_Tuition - this.ApplicationService.getAwardData().applicants[i].ConsiderAward_F2;
                    } else {
                        this.$.awardPutObject.applicants[i].Act_Award_F1 = null;
                        this.$.awardPutObject.applicants[i].Act_Award_F2 = null;
                    }
                }
            }
        }
    },
    // create the budgetPutObject from awardData
    buildBudgetPutObject: function(applicants) {
        this.$.budgetPutObject = [];
        for (let i = 0; i < applicants.length; i++) {
            this.$.selectedAccount[i] = "";
            this.$.remainingAward[i] = 0;
            this.$.budgetPutObject[i] = [];

            for (let j = 0; j < applicants[i].budgets.length; j++) {
                applicants[i].budgets[j].accountID = parseInt(applicants[i].budgets[j].accountID);
                let accountID = applicants[i].budgets[j].accountID;
                this.$.budgetPutObject[i][accountID] = {};
                this.$.budgetPutObject[i][accountID].schoolID = this.authServiceFactory.getAuth().schoolID;
                this.$.budgetPutObject[i][accountID].applicationID = applicants[i].applicationID;
                if (applicants[i].budgets[j].recordID) {
                    this.$.budgetPutObject[i][accountID].recordID = applicants[i].budgets[j].recordID;
                }
                this.$.budgetPutObject[i][accountID].accountID = applicants[i].budgets[j].accountID;
                this.$.budgetPutObject[i][accountID].award = applicants[i].budgets[j].award; 
                this.$.budgetPutObject[i][accountID].applicantID = applicants[i].recordID;
            }
            this.calculateRemainingAward(i, 0);
        }
    },
    // Utility method
    getField: function(item, field)
    {
        if (item['x' + field] == null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },

    // submit/consider award
    setAward: function(instance)
    {
        let deferred = this.$q.defer();
        let putObject = this.$.awardPutObject;
        putObject.type = {0:'Award',1:'Consider',2:'Reject'}[this.$.awardType];

        // Determine if the award is greater than the tuition
        // TODO: offload this to the frontend; we can do this onchange rather than onsubmit,
        // TODO: Possibly do this in the partial or in the calculateRemainingAward method
        this.$.err = [];
        for (let i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++)
        {
            if (putObject.type === 'Award' || putObject.type === 'Consider') {
                if (parseInt(putObject.applicants[i].Act_Award) > parseInt(putObject.applicants[i].App_Tuition)) {
                    this.$.err[i] = true;
                }
                if (this.$.remainingAward[i] < 0) {
                    this.$.err[i] = true;
                }
            }
        }

        if (this.$.err.length==0)
        {
            var sum = 0; // total award
            var awd = []; // awards
            for (let i = 0; i < putObject.applicants.length; i++) {
                putObject.applicants[i].Act_Award = parseInt(putObject.applicants[i].Act_Award) || 0; //set award to 0 if its null
                awd[i] = parseInt(putObject.applicants[i].Act_Award);
                if (this.$.schoolinfo.Award_Pref_2 === 1 && !this.ApplicationService.isFamilyTwoSituation()) {
                    putObject.applicants[i].Act_Award_F1 = putObject.applicants[i].Act_Award;
                    putObject.applicants[i].Act_Award_F2 = 0;
                }
                if (this.$.schoolinfo.Award_Pref_1==1)
                    putObject.applicants[i].Act_Award = parseInt(putObject.applicants[i].App_Tuition) - parseInt(putObject.applicants[i].Act_Award);
                sum += parseInt(putObject.applicants[i].Act_Award); //parse int, return 0 if NaN
            }

            // if Rejecting, set awards to 0 and zero out budgets
            if (putObject.type === 'Reject' || sum == 0) { 
                for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
                    putObject.applicants[i].Act_Award = 0;
                }
                this.clearBudgets();
            }

            // put award data
            this.AppModelService.AwardApplicant(this.ApplicationService.getAwardData().app[0].applicationID, putObject)
                .then( () => {
                    this.ApplicationService.getAwardData().awardGiven = sum;
                    this.ApplicationService.getAwardData().app[0].Award_Amount = sum;
                    if (putObject.type === 'Award' || putObject.type === 'Consider') { // if Award or Consider
                        
                        // Reset data from putObject
                        let awardVarName = putObject.type === 'Award' ? 'ActAward' : putObject.type == 'Consider' ? 'ConsiderAward' : '';
                        for (let i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
                            /*if (this.$.schoolinfo.Award_Pref_1 == 1)
                                this.ApplicationService.getAwardData().applicants[i][awardVarName] = putObject.applicants[i].App_Tuition - putObject.applicants[i].Act_Award;
                            else*/
                                this.ApplicationService.getAwardData().applicants[i][awardVarName] = putObject.applicants[i].Act_Award;

                            if (this.$.schoolinfo.Award_Pref_2 === 1) {
                                this.ApplicationService.getAwardData().applicants[i][awardVarName+"_F1"] = this.ApplicationService.isFamilyTwoSituation() ? putObject.applicants[i].Act_Award_F1 : putObject.applicants[i].Act_Award;
                                this.ApplicationService.getAwardData().applicants[i][awardVarName+"_F2"] = putObject.applicants[i].Act_Award_F2;
                            }

                            putObject.applicants[i].Act_Award = awd[i];
                        }
                    }

                    this.ApplicationSideBarService.setBin('Status_' + putObject.type);
                    this.$q.all([
                        this.BinFactory.retrieveData(),
                        this.setBudget()
                    ]).then(() => {
                        this.DetermineAwardService.resetAwardComplete();
                        instance.options.callMe(null, 200, null, null, instance);
                        deferred.resolve();
                    });
                });
        }
        else 
        {
            instance.stop(-1)
        }
        return deferred.promise;
    },

    // set budgets to 0 for rejection
    clearBudgets: function() {
        for (var i in this.$.budgetPutObject) { //for each applicant
            for (var j in this.$.budgetPutObject[i]) { //for each budget
                this.$.budgetPutObject[i][j].award = 0;
            }
        }
    },

    // submit budgets and replace recordIDs, budget numbers in other objects
    setBudget: function()
    {
        let defer = this.$q.defer();
        //compress array
        let compressedBudgets = [];
        for (var i in this.$.budgetPutObject) { //compress budgetputobject into array
            for (var j in this.$.budgetPutObject[i]) {
                compressedBudgets.push(this.$.budgetPutObject[i][j]);
            }
        }
        this.BudgetsModelService.put(this.ApplicationService.getAwardData().app[0].applicationID, compressedBudgets).then( (response) => {
            this.BudgetsModelService.getFromApp(this.ApplicationService.getAwardData().app[0].applicationID).then((data) => {
                // copy new budget numbers back to applicant object
                for (let i in data.data) {
                    for (var applicant in this.ApplicationService.getAwardData().applicants) {
                        for (var budget in this.ApplicationService.getAwardData().applicants[applicant].budgets) {
                            if (data.data[i].applicantID == this.ApplicationService.getAwardData().applicants[applicant].budgets[budget].applicantID
                                && data.data[i].accountID == this.ApplicationService.getAwardData().applicants[applicant].budgets[budget].accountID) {
                                this.ApplicationService.getAwardData().applicants[applicant].budgets[budget].award = data.data[i].award;
                                this.ApplicationService.getAwardData().applicants[applicant].budgets[budget].recordID = data.data[i].recordID;
                            }
                        }
                    }
                }
                // rebuild budgetPutObject based on applicants
                this.buildBudgetPutObject(this.ApplicationService.getAwardData().applicants);
                defer.resolve();
            });
        });
        return defer.promise;
    }

});
